import { usePage } from '@inertiajs/inertia-react';
import React from 'react'

export const getColumnTable = ({col, idx, keyName="unk", handleBaseProps}) => {
	const name = typeof col==="object" ? col.name : col;
	let cprops = typeof col==="object" ? col.props : undefined;
	if (handleBaseProps) cprops = handleBaseProps(cprops);
	return <th key={"col-"+keyName+"-"+idx} {...cprops}>{name}</th>
}

export const withPageData = (WrapComp, {mapPage}={}) => {
	return React.forwardRef((props, ref) => {
		const pageProps = useProps()
		const extras = mapPage ? mapPage(pageProps, props) : pageProps;
		//const extraProps = listable ? {list, extras: rest} : {list, ...rest};
		return <WrapComp {...props} {...extras} ref={ref} />;
	});
}

export const withPageProps = (WrapComp, {mapPageProps}={}) => {
	return React.forwardRef((props, ref) => {
		const pageProps = useProps()
		const extras = mapPageProps ? mapPageProps(pageProps, props) : pageProps;
		//const extraProps = listable ? {list, extras: rest} : {list, ...rest};
		return <WrapComp {...extras} {...props} ref={ref} />;
	});
}

export function useUrlReadFile(file) {
	const [url, setUrl] = React.useState(null);
	React.useEffect(() => {
		if (file) {
			const reader = new FileReader();

			reader.onload = function(e) {
				setUrl(e.target.result);
			}

			reader.readAsDataURL(file);
		} else {
			setUrl(undefined)
		}
	}, [file]);
	return url;
}

export function useProps() {
	const {props} = usePage();
	return props||{};
}

export function parrafos(str, {as: Comp, ...options}={}) {
	return (str||'').replace(/\n\r|\r\n/g, '\n').split('\n').filter(val=>!!val.trim()).map((val, idx)=>{
		if (!val) return null
		if (Comp) return <Comp key={'p-gen-'+idx} {...options?.props}>{val}</Comp>
		return <p key={'p-gen-'+idx} {...options?.props}>{val}</p>
	});
}

export function creadoPorComun(users, accounts, {user_id, account_id: account}={}) {
	const {auth} = useProps();
	const {name: userName, account_id} = users?.find(val=>val?.id && val.id==props.user_id)||{};
	if (!account) account = account_id;
	const {name: accountName} = accounts?.find(val=>val?.id && val.id==(account))||{};
	/*if (account === ) {
	
	}*/// TODO TERMINAR LUEGO
}
